import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityCZ extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Prohlášení o přístupnosti - CamAPS FX</title>
                    <meta name="title" content="Prohlášení o přístupnosti"/>
                    <meta name="description"
                          content="Společnost CamDiab se zavázala podporovat a zlepšovat přístupnost a použitelnost svých digitálních produktů pro všechny osoby, včetně osob se zdravotním postiže"/>
                    <meta property="og:locale" content="cs"/>
                    <meta name="keywords" content="prohlášení o přístupnosti"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Prohlášení o přístupnosti</h1>
                                <h3>Verze ze dne 11. září 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    Společnost CamDiab se zavázala podporovat a zlepšovat přístupnost a použitelnost svých digitálních produktů pro všechny osoby, včetně osob se zdravotním postižením.
                                </p>
                                <h2>
                                    Stav souladu
                                </h2>
                                <p>
                                    Společnost CamDiab usiluje o dosažení souladu s Pokyny pro přístupnost webového obsahu (WCAG) verze 2.2 na úrovni AA (WCAG 2.2 AA). Tyto celosvětově uznávané pokyny pomáhají zpřístupnit webový obsah všem.
                                </p>
                                <h2>
                                    Další opatření na podporu přístupnosti
                                </h2>
                                <p>
                                    Společnost CamDiab přijímá mimo jiné následující dodatečná opatření, aby byl náš digitální obsah snadněji použitelný:
                                </p>
                                <ul>
                                    <li>Průběžně školit naše zaměstnance v oblasti přístupnosti</li>
                                    <li>Využívat formální metody zajištění kvality přístupnosti prostřednictvím hodnocení třetí stranou</li>
                                    <li>Stanovit jasné cíle a odpovědnosti v oblasti přístupnosti</li>
                                </ul>
                                <h2>
                                    Zpětná vazba
                                </h2>
                                <p>
                                    Uvítáme vaše připomínky k tomu, jak můžeme zlepšit naše digitální produkty pro uživatele se zdravotním postižením. Pokud máte potíže se zobrazením nebo procházením našeho obsahu nebo si všimnete obsahu, funkce či funkcionality, o níž se domníváte, že není plně přístupná osobám se zdravotním postižením, kontaktujte nás prostřednictvím našeho e-mailu podpory: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Vaši zpětnou vazbu bereme vážně a budeme ji zohledňovat při hodnocení možností, jak vyhovět potřebám všech našich zákazníků, a při posuzování našich celkových zásad přístupnosti. Přestože nemáme kontrolu nad obsahem poskytovaným dodavateli třetích stran, důrazně je vyzýváme, aby poskytovali obsah, který je přístupný a uživatelsky přívětivý.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
